import React, { memo } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './GameCustomField.scss';

export const GameCustomFieldBare: React.FC<Types.IGameCustomFieldProps> = ({ game, className = '', field }) => {
    const translate = useTranslations();
    const { gameCustomFieldsData = [] } = game;
    const customField = gameCustomFieldsData.find((item) => item.name === field);

    if (!customField || customField?.tpe !== 'text' || !customField?.value) {
        return null;
    }

    const { value } = customField;

    return <span className={`${style.gameCustomField} ${className} cms-games-grid-game-custom-field`}>{translate(value)}</span>;
};

export const GameCustomField = memo(GameCustomFieldBare);
